import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 90vh;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/wrapper.js